import { render } from "./S118071.vue?vue&type=template&id=6a64107a"
const script = {}
script.render = render

export default script